import { render, staticRenderFns } from "./FormChangePassword.vue?vue&type=template&id=db5b472a"
import script from "./FormChangePassword.vue?vue&type=script&lang=js"
export * from "./FormChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports